import React, { useEffect, useState, useMemo } from "react";
import axiosInstance from "../../../../axios";
import { getPaginatedData } from "../../../../_helpers";
import { Loading } from "../../../Other/Loading";
import Pagination from "./Pagination";
import { FaSort } from "react-icons/fa";

const { REACT_APP_LOGIN_API_BASEURL } = process.env;


const TeacherReport = () => {
  const [instructorData, setInstructorData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" }); // Sorting state
  const [instructorStats, setInstructorStats] = useState();
  const { data, startIndex, totalPageCount } = getPaginatedData(
    instructorData,
    currentPage
  );
    useEffect(() => {
      const fetchInstructorStats = async () => {
        try {
          const res = await axiosInstance.get("admin/instructor-statistics");
          setInstructorStats(res.data.data);
        } catch (error) {
          console.error("Error fetching instructor statistics:", error.message);
        }
      };
  
      fetchInstructorStats();
    }, []);
  
  useEffect(() => {
    const fetchInstructorReport = async () => {
      try {
        const res = await axiosInstance.get(`${REACT_APP_LOGIN_API_BASEURL}/v2/instructor-report`);
        setInstructorData(res?.data?.data);
      } catch (error) {
        console.error("Error fetching instructor report:", error.message);
      }
    };

    fetchInstructorReport();
  }, []);

  const staticData = [
    {
      name: "Total Instructors",
      total: instructorStats?.totalInstructors || "0",
      boxShadow: "Dashboard-color-one",
      color: "color-one",
    },
    {
      name: "Active Instructors",
      total: instructorStats?.activeInstructors || "0",
      boxShadow: "Dashboard-color-four",
      color: "color-four",
    },
    {
     name: "Pending Request",
      total: instructorStats?.pendingVerification || "0",
      boxShadow: "Dashboard-color-two",
      color: "color-two",
    },
    
  ];

  // Sorting handler
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  // Sorted data
  const sortedData = useMemo(() => {
    if (!sortConfig.key) return instructorData;
    const sorted = [...instructorData].sort((a, b) => {
      let aValue = a[sortConfig.key];
      let bValue = b[sortConfig.key];

      // Handle numeric sorting
      if (typeof aValue === "number" && typeof bValue === "number") {
        return sortConfig.direction === "asc"
          ? aValue - bValue
          : bValue - aValue;
      }

      // Handle string sorting
      if (typeof aValue === "string" && typeof bValue === "string") {
        return sortConfig.direction === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }

      return 0;
    });
    return sorted;
  }, [instructorData, sortConfig]);

  // Helper to render sort icons
  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) return <FaSort className="text-gray-400" />;
    return sortConfig.direction === "asc" ? "▲" : "▼";
  };

  return (
    <div className="width-0">
      <div className="dashboard-container-new">
        <p>Report For Teachers</p>
        <div>
          <button className="lastmonth-btn">Last Month</button>
          <button className="export-btn">Export</button>
        </div>
      </div>

      <div className="flex-dashboard-new-1">
        {staticData?.map((item, index) => (
          <div className={`box-shadow-06 ${item.boxShadow}`} key={index}>
            <p className="font-custom-p">{item.name}</p>
            <p className={`font-increase ${item.color}`}>{item.total}</p>
          </div>
        ))}
      </div>

      <div className="page-data-new">
        {data?.length > 0 ? (
          <p className="showing-result">
            Showing page {currentPage} of {totalPageCount} results
          </p>
        ) : (
          <p className="showing-result">Showing 0 result</p>
        )}
      </div>

      <div className="instructor-table">
        {data.length === 0 ? (
          <Loading />
        ) : (
          <table className="table-width-100">
            <thead>
              <tr>
                <th
                  onClick={() => handleSort("Sno")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="flex items-center gap-1">
                    S.no {renderSortIcon("Sno")}
                  </div>
                </th>
                <th
                  onClick={() => handleSort("UserId")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="flex items-center gap-1">
                    Instructor Id {renderSortIcon("UserId")}
                  </div>
                </th>
                <th
                  onClick={() => handleSort("InstructorName")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="flex items-center gap-1">
                    Instructor Name {renderSortIcon("InstructorName")}
                  </div>
                </th>
                <th
                  onClick={() => handleSort("PaidCourses")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="flex items-center gap-1">
                    Paid Courses {renderSortIcon("PaidCourses")}
                  </div>
                </th>
                <th
                  onClick={() => handleSort("FreeCourses")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="flex items-center gap-1">
                    Free Courses {renderSortIcon("FreeCourses")}
                  </div>
                </th>
                <th
                  onClick={() => handleSort("ContentLength")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="flex items-center gap-1">
                    Content Length {renderSortIcon("ContentLength")}
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {sortedData?.map((ele, index) => {
                return (
                  <tr key={index}>
                    <td className="cell">{startIndex + index}</td>
                    <td className="cell">{ele.UserId}</td>
                    <td className="cell">{ele.InstructorName}</td>
                    <td className="cell">{ele.PaidCourses}</td>
                    <td className="cell">{ele.FreeCourses}</td>
                    <td className="cell">
                      {ele?.ContentLength === null ? 0 : ele?.ContentLength}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
      <div className="pageNumbers-sudents">
        <Pagination
          className="pageNumbers-sudents"
          currentPage={currentPage}
          totalCount={10}
          pageSize={totalPageCount}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </div>
    </div>
  );
};

export default TeacherReport;
